import {createGlobalStyle} from 'styled-components'
import styledNormalize from 'styled-normalize'

import {spacingUnit} from '../cssConstants/spacing'
import {weightNormal} from '../cssConstants/typography'
import {colorText} from '../cssConstants/colors'

import Museo300 from '../fonts/Museo300-Regular.woff'
import Museo700 from '../fonts/Museo700-Regular.woff'
import Belista from '../fonts/Belista.ttf'

export const GlobalStyle = createGlobalStyle`
  ${styledNormalize};

  @font-face {
    font-family: 'Museo 300';
    font-style: normal;
    font-weight: normal;
    src: local("Museo 300"), local("Museo-300"), url(${Museo300}) format("woff");
  }

  @font-face {
    font-family: 'Museo 700';
    font-style: normal;
    font-weight: normal;
    src: local("Museo 700"), local("Museo-700"), url(${Museo700}) format("woff");
  }

  @font-face {
    font-family: 'Belista';
    font-style: normal;
    font-weight: normal;
    src: local("Belista"), local("Belista"), url(${Belista}) format('truetype');
  }

  html {
    font-size: 16px;
    font-family: Lato, Helvetica, system, -apple-system, BlinkMacSystemFont, "Segoe UI", "Ubuntu", "Roboto", "Oxygen", "Cantarell", "Open Sans", "Fira Sans", "Droid Sans", "Arial", sans-serif;
    font-weight: ${weightNormal};
    line-height: ${spacingUnit};
    color: ${colorText};
    min-height: 100%;

    position: relative;

    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    scroll-behavior: smooth;
  }

  body {
    margin-left: revert;
    margin-right: revert;
  }

  #___gatsby {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
  }
`
